(function () {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initQOT(container) {
    var productId = container.dataset.productId;
    var variants  = (window.__qotVariants || {})[productId] || [];
    var minTotal  = parseInt((window.__qotMinQty || {})[productId] || '0', 10) || 0;

    var steppers     = container.querySelectorAll('.qot__stepper');
    var messageEl    = container.querySelector('.qot__message');
    var minNotice    = container.querySelector('.qot__min-notice');
    var minRemaining = container.querySelector('.qot__min-remaining');
    var addBtn       = document.querySelector(
      '.product-form__submit, button[name="add"], [data-add-to-cart]'
    );

    var selectedColor   = null;
    var selectedFabric  = null;
    var cartQty         = 0;
    var cartItemCount   = 0;
    var productTitle    = (window.__qotProductTitle || {})[productId] || '';
    var productImage    = (window.__qotProductImage || {})[productId] || '';

    /* ── Upload properties (Uploadery / Globo / any app) ───────
       Reads hidden properties[...] inputs injected by upload apps
       into the product form and passes them as line item properties. */

    function getUploadProperties() {
      var props = {};
      var uploaderyIndex = 1;
      // Search whole document — some apps inject outside the product form
      document.querySelectorAll('[name^="properties["]').forEach(function (el) {
        var match = el.name.match(/^properties\[(.+)\]$/);
        if (!match || !el.value) return;
        var key = match[1];
        if (key.charAt(0) === '_') return; // strip internal app keys (_has_gpo, etc.)
        // Rename uploadery_* keys so Uploadery's fetch interceptor doesn't
        // recognise them as its own and strip/reprocess them on AJAX requests
        if (/^uploadery_/i.test(key)) {
          props['Design File ' + uploaderyIndex] = el.value;
          uploaderyIndex++;
        } else {
          props[key] = el.value;
        }
      });
      return props;
    }

    /* ── Native picker sync ──────────────────────────────────── */

    function syncFromNativePicker() {
      var form  = document.querySelector('form[action*="/cart/add"]');
      var input = form && form.querySelector('input[name="id"]');
      if (!input) return;
      var vid = parseInt(input.value, 10);
      var v   = variants.find(function (v) { return v.id === vid; });
      if (!v) return;
      selectedColor  = v.color_index  >= 0 ? v.options[v.color_index]  : null;
      selectedFabric = v.fabric_index >= 0 ? v.options[v.fabric_index] : null;
    }

    // Hide native size option — CSS handles most cases instantly,
    // this is a JS fallback for themes that re-render the picker
    function hideNativeSizeOption() {
      var sizeLabels = ['size', 'talle', 'talla'];
      document.querySelectorAll('.product-form__input').forEach(function (el) {
        var label = el.querySelector('.form__label, label');
        if (label && sizeLabels.indexOf(label.textContent.trim().toLowerCase()) !== -1) {
          el.style.display = 'none';
          return;
        }
        var firstInput = el.querySelector('input[type="radio"], select');
        if (firstInput && sizeLabels.indexOf((firstInput.name || '').toLowerCase()) !== -1) {
          el.style.display = 'none';
        }
      });
    }

    function watchNativePicker() {
      // Dawn fires 'variant:change' with { detail: { variant } }
      document.addEventListener('variant:change', function (e) {
        var variant = e.detail && e.detail.variant;
        if (variant) {
          var v = variants.find(function (v) { return v.id === variant.id; });
          if (v) {
            selectedColor  = v.color_index  >= 0 ? v.options[v.color_index]  : null;
            selectedFabric = v.fabric_index >= 0 ? v.options[v.fabric_index] : null;
          }
        } else {
          syncFromNativePicker();
        }
        // Re-hide size option in case the picker re-rendered
        hideNativeSizeOption();
        // Keep existing quantities — only disable sizes unavailable in new variant
        updateTable();
      });

      // Fallback: watch the hidden id input directly
      var form    = document.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.addEventListener('change', function () {
          syncFromNativePicker();
          hideNativeSizeOption();
          updateTable();
        });
      }
    }

    /* ── Variant lookup ──────────────────────────────────────── */

    function getVariant(color, size) {
      return variants.find(function (v) {
        var ci = v.color_index  >= 0 ? v.color_index  : null;
        var si = v.size_index   >= 0 ? v.size_index   : null;
        var fi = v.fabric_index >= 0 ? v.fabric_index : null;
        var okColor  = ci === null || v.options[ci] === color;
        var okSize   = si === null || v.options[si] === size;
        var okFabric = fi === null || selectedFabric === null || v.options[fi] === selectedFabric;
        return okColor && okSize && okFabric;
      });
    }

    /* ── Qty helpers ─────────────────────────────────────────── */

    function getQty(stepper) {
      var input = stepper.querySelector('.qot__qty-input');
      return input ? Math.max(0, parseInt(input.value, 10) || 0) : 0;
    }

    function setQty(stepper, qty) {
      stepper.dataset.value = qty;
      var input = stepper.querySelector('.qot__qty-input');
      if (input) input.value = qty;
    }

    function changeQty(stepper, delta) {
      var input = stepper.querySelector('.qot__qty-input');
      if (!input || input.disabled) return;
      var qty = Math.max(0, getQty(stepper) + delta);
      setQty(stepper, qty);
      var size      = stepper.dataset.size;
      var variant   = getVariant(selectedColor, size);
      var priceCell = container.querySelector('.qot__price-cell[data-size="' + size + '"]');
      renderPriceCell(priceCell, variant, qty);
      updateMinUI();
    }

    function getTotalQty() {
      var total = 0;
      steppers.forEach(function (s) { total += getQty(s); });
      return total;
    }

    /* ── Effective minimum (accounting for cart) ─────────────── */

    function getEffectiveMin() {
      return Math.max(0, minTotal - cartQty);
    }

    /* ── Price cell ──────────────────────────────────────────── */

    function renderPriceCell(priceCell, variant, qty) {
      if (!priceCell) return;
      if (!variant || !variant.available) {
        priceCell.innerHTML = '<span class="unit-price">—</span><span class="subtotal">—</span>';
        priceCell.classList.add('is-oos');
        return;
      }
      priceCell.classList.remove('is-oos');
      priceCell.innerHTML =
        '<span class="unit-price">' + formatMoney(variant.price) + ' ea</span>' +
        '<span class="subtotal">'   + formatMoney(variant.price * qty) + '</span>';
    }

    /* ── Cart qty loader ─────────────────────────────────────── */

    function loadCartQty(callback) {
      var ids = variants.map(function (v) { return v.id; });
      // cache: 'no-store' forces a fresh request, bypassing browser cache
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartQty       = 0;
          cartItemCount = cart.item_count;
          cart.items.forEach(function (item) {
            if (ids.indexOf(item.variant_id) !== -1) cartQty += item.quantity;
          });
          if (callback) callback();
        })
        .catch(function () { if (callback) callback(); });
    }

    /* ── Min-notice UI ───────────────────────────────────────── */

    function updateMinUI() {
      if (minTotal <= 0) return;
      var entered      = getTotalQty();
      var effectiveMin = getEffectiveMin();
      var remaining    = Math.max(0, effectiveMin - entered);
      var met          = remaining === 0;

      if (minNotice) {
        minNotice.style.display = met ? 'none' : '';
        if (minRemaining) minRemaining.textContent = remaining;
        var cartNote = minNotice.querySelector('.qot__cart-note');
        if (cartQty > 0) {
          if (!cartNote) {
            cartNote = document.createElement('span');
            cartNote.className = 'qot__cart-note';
            minNotice.appendChild(cartNote);
          }
          cartNote.textContent = ' (' + cartQty + ' already in your cart)';
        } else if (cartNote) {
          cartNote.textContent = '';
        }
      }

      if (addBtn) {
        addBtn.style.opacity       = met ? '' : '0.5';
        addBtn.style.pointerEvents = met ? '' : 'none';
        addBtn.setAttribute('aria-disabled', met ? 'false' : 'true');
      }
    }

    /* ── Table update ────────────────────────────────────────── */

    function updateTable() {
      steppers.forEach(function (stepper) {
        var size      = stepper.dataset.size;
        var variant   = getVariant(selectedColor, size);
        var priceCell = container.querySelector('.qot__price-cell[data-size="' + size + '"]');
        var input     = stepper.querySelector('.qot__qty-input');

        if (!variant || !variant.available) {
          stepper.dataset.variantId = '';
          setQty(stepper, 0);
          stepper.classList.add('is-disabled');
          if (input) input.disabled = true;
          renderPriceCell(priceCell, null, 0);
        } else {
          stepper.dataset.variantId = variant.id;
          stepper.classList.remove('is-disabled');
          if (input) input.disabled = false;
          // Keep existing qty, just refresh the price cell
          renderPriceCell(priceCell, variant, getQty(stepper));
        }
      });

      updateMinUI();
    }

    /* ── Input + button listeners ────────────────────────────── */

    function initInputListeners() {
      steppers.forEach(function (stepper) {
        var input   = stepper.querySelector('.qot__qty-input');
        var btnPlus = stepper.querySelector('.qot__btn--plus');
        var btnMin  = stepper.querySelector('.qot__btn--minus');

        if (btnPlus) btnPlus.addEventListener('click', function () { changeQty(stepper, 1); });
        if (btnMin)  btnMin.addEventListener('click',  function () { changeQty(stepper, -1); });

        if (input) {
          // Select all on focus
          var justFocused = false;
          input.addEventListener('focus', function () { justFocused = true; input.select(); });
          input.addEventListener('mouseup', function (e) {
            if (justFocused) { e.preventDefault(); justFocused = false; }
          });

          input.addEventListener('input', function () {
            var qty       = Math.max(0, parseInt(input.value, 10) || 0);
            stepper.dataset.value = qty;
            var size      = stepper.dataset.size;
            var variant   = getVariant(selectedColor, size);
            var priceCell = container.querySelector('.qot__price-cell[data-size="' + size + '"]');
            renderPriceCell(priceCell, variant, qty);
            updateMinUI();
          });

          input.addEventListener('blur', function () {
            var qty = Math.max(0, parseInt(input.value, 10) || 0);
            input.value = qty;
            stepper.dataset.value = qty;
          });
        }
      });
    }

    /* ── Add to cart ─────────────────────────────────────────── */

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var entered      = getTotalQty();
        var effectiveMin = getEffectiveMin();

        if (effectiveMin > 0 && entered < effectiveMin) {
          var need = effectiveMin - entered;
          var msg  = 'Minimum order is ' + minTotal + ' units total. Add ' + need + ' more.';
          if (cartQty > 0) msg += ' (' + cartQty + ' already in your cart.)';
          showMessage(msg, 'error');
          return;
        }

        // Validate Uploadery required upload
        // #uploadery-container is always in the DOM when the app block is present,
        // even before any file is selected — so it's the reliable presence signal.
        if (document.querySelector('#uploadery-container')) {
          var uploaderyInputs = document.querySelectorAll('[name^="properties[uploadery_"]');
          var hasUploadedFile = Array.prototype.some.call(uploaderyInputs, function (el) {
            return el.value.trim() !== '';
          });
          if (!hasUploadedFile) {
            showUploadError('Please upload an image before adding to cart.');
            return;
          } else {
            clearUploadError();
          }
        }

        var properties = getUploadProperties();
        var items = [];
        steppers.forEach(function (stepper) {
          var qty       = getQty(stepper);
          var variantId = parseInt(stepper.dataset.variantId, 10);
          if (qty > 0 && variantId) {
            var item = { id: variantId, quantity: qty };
            if (Object.keys(properties).length > 0) item.properties = properties;
            items.push(item);
          }
        });

        if (items.length === 0) {
          showMessage('Select at least one quantity.', 'error');
          return;
        }

        addBtn.disabled = true;
        clearMessage();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: items,
            sections: ['cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function (response) {
            // Capture what was added before resetting
            var addedItems = [];
            steppers.forEach(function (stepper) {
              var qty = getQty(stepper);
              if (qty > 0) addedItems.push({ size: stepper.dataset.size, qty: qty });
            });

            // Reset inputs
            steppers.forEach(function (stepper) {
              setQty(stepper, 0);
              var size      = stepper.dataset.size;
              var variant   = getVariant(selectedColor, size);
              var priceCell = container.querySelector('.qot__price-cell[data-size="' + size + '"]');
              renderPriceCell(priceCell, variant, 0);
            });

            refreshCartBubble(response.sections);
            loadCartQty(function () {
              updateMinUI();
              showNotify(addedItems);
            });
          })
          .catch(function () { showMessage('Something went wrong. Please try again.', 'error'); })
          .finally(function () { addBtn.disabled = false; });
      });
    }

    /* ── Cart notification modal ─────────────────────────────── */

    var notify      = null;
    var notifyTimer = null;

    function buildNotify() {
      if (notify) return;
      notify = document.createElement('div');
      notify.className = 'qot-notify';
      notify.setAttribute('role', 'dialog');
      notify.setAttribute('aria-modal', 'false');
      document.body.appendChild(notify);

      notify.addEventListener('click', function (e) {
        if (e.target.classList.contains('qot-notify__close') ||
            e.target.classList.contains('qot-notify__btn--continue')) {
          hideNotify();
        }
      });
    }

    function showNotify(addedItems) {
      buildNotify();
      clearTimeout(notifyTimer);

      // Build meta line (Color / Fabric)
      var meta = [];
      if (selectedColor)  meta.push('Color: ' + selectedColor);
      if (selectedFabric) meta.push('Fabric: ' + selectedFabric);

      // Rows per size
      var itemsHtml = addedItems.map(function (item) {
        return '<div class="qot-notify__item">' +
          '<span class="qot-notify__size">Size ' + item.size + '</span>' +
          '<span class="qot-notify__qty">&times;&nbsp;' + item.qty + '</span>' +
          '</div>';
      }).join('');

      var imgHtml = productImage
        ? '<img class="qot-notify__img" src="' + productImage + '" alt="" loading="lazy">'
        : '';

      notify.innerHTML =
        '<div class="qot-notify__header">' +
          '<span class="qot-notify__heading">' +
            '<span class="qot-notify__check">&#10003;</span>' +
            'Items added to your cart' +
          '</span>' +
          '<button class="qot-notify__close" type="button" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="qot-notify__product">' +
          imgHtml +
          '<div class="qot-notify__info">' +
            (productTitle ? '<p class="qot-notify__product-title">' + productTitle + '</p>' : '') +
            (meta.length  ? '<p class="qot-notify__product-meta">' + meta.join('<br>') + '</p>' : '') +
          '</div>' +
        '</div>' +
        '<div class="qot-notify__items">' + itemsHtml + '</div>' +
        '<div class="qot-notify__actions">' +
          '<a href="/cart" class="qot-notify__btn qot-notify__btn--cart">View cart (' + cartItemCount + ')</a>' +
          '<a href="/checkout" class="qot-notify__btn qot-notify__btn--checkout">Check out</a>' +
          '<button class="qot-notify__btn qot-notify__btn--continue" type="button">Continue shopping</button>' +
        '</div>';

      // Re-attach close listener after innerHTML rebuild
      notify.querySelector('.qot-notify__close').addEventListener('click', hideNotify);
      notify.querySelector('.qot-notify__btn--continue').addEventListener('click', hideNotify);

      // Animate in
      requestAnimationFrame(function () {
        notify.classList.add('is-visible');
      });

      // Auto-dismiss after 6 seconds
      notifyTimer = setTimeout(hideNotify, 6000);
    }

    function hideNotify() {
      if (notify) notify.classList.remove('is-visible');
      clearTimeout(notifyTimer);
    }

    /* ── Cart icon bubble refresh ────────────────────────────── */

    function refreshCartBubble(sections) {
      if (sections && sections['cart-icon-bubble']) {
        var parser   = new DOMParser();
        var doc      = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        var newEl    = doc.querySelector('#shopify-section-cart-icon-bubble');
        var existing = document.querySelector('#shopify-section-cart-icon-bubble');
        if (newEl && existing) { existing.innerHTML = newEl.innerHTML; return; }
      }
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count    = cart.item_count;
          var cartIcon = document.getElementById('cart-icon-bubble');
          if (!cartIcon) return;
          var bubble = cartIcon.querySelector('.cart-count-bubble');
          if (count > 0) {
            if (!bubble) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              cartIcon.appendChild(bubble);
            }
            bubble.classList.remove('hidden');
            bubble.innerHTML =
              '<span aria-hidden="true">' + count + '</span>' +
              '<span class="visually-hidden">' + count + ' items</span>';
          } else if (bubble) {
            bubble.classList.add('hidden');
          }
        })
        .catch(function () {});
    }

    /* ── Uploadery error (shown next to the upload widget) ────── */

    function getUploadErrorEl() {
      var id = 'qot-upload-error';
      var el = document.getElementById(id);
      if (!el) {
        var container = document.querySelector('#uploadery-container');
        if (!container) return null;
        el = document.createElement('p');
        el.id = id;
        el.style.cssText = 'margin:0.5rem 0 0; font-size:1.375rem; font-weight:600; color:rgb(var(--color-error,176,0,32));';
        container.parentNode.insertBefore(el, container.nextSibling);
      }
      return el;
    }

    function showUploadError(text) {
      var el = getUploadErrorEl();
      if (el) el.textContent = text;
    }

    function clearUploadError() {
      var el = document.getElementById('qot-upload-error');
      if (el) el.textContent = '';
    }

    /* ── Message helpers ─────────────────────────────────────── */

    function showMessage(text, type) {
      if (messageEl) { messageEl.textContent = text; messageEl.className = 'qot__message ' + type; }
    }
    function clearMessage() {
      if (messageEl) { messageEl.textContent = ''; messageEl.className = 'qot__message'; }
    }

    /* ── Bootstrap ───────────────────────────────────────────── */

    // Clear upload error as soon as Uploadery inserts the hidden input (programmatic — no change event)
    var uploadObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          var inputs = node.name
            ? [node]
            : Array.prototype.slice.call(node.querySelectorAll('[name^="properties[uploadery_"]'));
          for (var k = 0; k < inputs.length; k++) {
            if (/^properties\[uploadery_/.test(inputs[k].name) && inputs[k].value.trim() !== '') {
              clearUploadError();
              return;
            }
          }
        }
      }
    });
    uploadObserver.observe(document.body, { childList: true, subtree: true });

    loadCartQty(function () {
      syncFromNativePicker();
      hideNativeSizeOption();
      watchNativePicker();
      updateTable();
      initInputListeners();
    });

    // Re-check cart on back/forward navigation.
    // We DON'T check e.persisted because Shopify themes often prevent bfcache,
    // making persisted=false even on genuine back navigations. Firing always is safe.
    window.addEventListener('pageshow', function () {
      loadCartQty(function () { updateMinUI(); });
    });

    // Also re-check when the window regains focus (user comes back from cart tab)
    window.addEventListener('focus', function () {
      loadCartQty(function () { updateMinUI(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.qot').forEach(initQOT);
  });

})();
